import * as React from "react";

function SvgFlowTree(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M22.21 18.16v-3a4.47 4.47 0 00-4.47-4.47h-2.55a1.9 1.9 0 01-1.91-1.91v-3a3.06 3.06 0 10-2.56 0v3a1.9 1.9 0 01-1.91 1.91H6.26a4.47 4.47 0 00-4.47 4.47v3a3.06 3.06 0 104.34 2.78 3.06 3.06 0 00-1.79-2.78v-3a1.91 1.91 0 011.92-1.91h2.55a4.37 4.37 0 001.91-.45v5.33a3.06 3.06 0 102.56 0v-5.3a4.37 4.37 0 001.91.45h2.55a1.91 1.91 0 011.92 1.91v3a3.07 3.07 0 102.55 0zM12 1.3a1.77 1.77 0 11-1.77 1.76A1.76 1.76 0 0112 1.3zM3.06 22.7a1.77 1.77 0 111.77-1.76 1.76 1.76 0 01-1.77 1.76zm8.94 0a1.77 1.77 0 111.77-1.76A1.76 1.76 0 0112 22.7zm8.94 0a1.77 1.77 0 111.76-1.76 1.76 1.76 0 01-1.76 1.76z" />
    </svg>
  );
}

const MemoSvgFlowTree = React.memo(SvgFlowTree);
export default MemoSvgFlowTree;
